export const findScrollableParent = (element: HTMLDivElement | null): HTMLDivElement | null => {
  if (!element) return null;
  while (element && element.parentElement) {
    const style = window.getComputedStyle(element.parentElement);
    if (style.overflow === "auto" || style.overflow === "scroll") return element.parentElement as HTMLDivElement;
    element = element.parentElement as HTMLDivElement;
  }
  return null;
};
